import { API } from 'aws-amplify';
import { publicSearchApiName } from '../../common/constants/api';

export const getFees = async () => {
  const res = await API.get(publicSearchApiName, '/fees', {});

  return res;
};
